import '../../css/mk-brand.css';
import React, {useEffect} from "react";
import ChefSunny from '../../media/featured/chef-sunny.jpeg';

function Panel() {
    useEffect(() => {}, );
    return (
        <div id="featured-chef" className="m-2">
            <div className="container bg-zinc-800 pt-4 px-4 md:px-32 pb-4 rounded-lg max-w-full">
                <div className="flex">
                    <div className="max-w-2xl mx-auto mb-10">
                        <div className="flex-row">
                            <div>
                                <div className="flex">
                                    <span className="text-5xl md:text-6xl lg:text-5xl font-bold">
                                      <span className="text-brand">Chef</span>-o-<span className="text-brand">rama</span>
                                    </span>
                                </div>
                                <div className="text-brand-text text-2xl text-right cursor-pointer hover:font-bold">
                                    featured Chef
                                </div>
                                <div className="border border-brand" />
                            </div>
                        </div>
                        <div className="flex">
                            <img className="p-2 rounded-full max-h-48" src={ChefSunny} />
                            <p className="text-white md:text-2xl p-4">
                                The <a className="underline text-brand" href="https://thecheforama.com/">Cheforama</a> is a decentralized Ecosystem for the food service community.
                                Chef Sunny creates fresh, innovative specials.
                                For him, new ideas and creations are always on rotation.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Panel;